import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { Observable } from 'rxjs';

import {
    Category
} from './../../../../../_models';
import {
    LiveSearchSelectComponent
} from './../../../../../shared/live-search-select';
import {
    DatePickerComponent
} from './../../../../../shared/date-picker';
@Component({
    selector: 'app-form-new',
    templateUrl: './form-new.component.html',
    styleUrls: ['./form-new.component.scss']
})
export class FormNewComponent {
    form: FormGroup;
    formHeader = {
        icon: 'fa fa-money',
        text: 'REGISTRAR'
    };
    types = [];
    options: any = {};
    curr: any;
    currentUser = JSON.parse(localStorage.getItem('currentUser')) || { "token": "" };
    endPoint = "";
    requests$: Observable<Object>;
    dataFetched: boolean = true;
    invalidDate: boolean = false;
    texts = {
        label: "Nombre",
        notFound: "Resultados no encontrados",
        loading: "Cargando...",
        none: "Seleccionar"
    }
    categoryTexts = {
        label: 'Categoría',
        loading: 'Cargando categorías',
        notFound: 'Categoría no registrada',
        none: 'Ninguna categoría'
    };
    dateTexts = {
        label: "",
        placeholder: ""
    }
    validation_messages = {
        'type': [
            { type: 'required', message: 'Campo requerido.' }
        ],
        'name': [
            { type: 'required', message: 'Campo requerido.' }
        ],
        'concept': [
            { type: 'required', message: 'Campo requerido.' },
            { type: 'minlength', message: 'Debe tener minimo 3 caracteres.' }
        ],
        'amount': [
            { type: 'required', message: 'Campo requerido.' }
        ],
        'category': [
            { type: 'required', message: 'Campo requerido.' }
        ],
        'date': [
            { type: 'required', message: 'Campo requerido.' }
        ]
    };
    listGetter: string = "getAll";
    @ViewChild('typeVal') selectTypeData: LiveSearchSelectComponent;
    @ViewChild('categoryVal') selectCategory: LiveSearchSelectComponent;
    @ViewChild('dobVal') dobPicker: DatePickerComponent;
    constructor(protected _fb: FormBuilder,
        protected _location: Location,
        protected _categoryFormModel: Category
    ) {
        this.form = _fb.group({
            'type': ['', Validators.compose([Validators.required])],
            'name': ['', Validators.compose([Validators.required])],
            'concept': ['', Validators.compose([Validators.required])], //, Validators.minLength(5)
            'amount': ['', Validators.compose([Validators.required])],
            'category': ['', Validators.compose([Validators.required])],
            'date': ['', Validators.compose([Validators.required])]
        });
        this.form.reset();
    }
    back() {
        this._location.back();
    }

    dateChanged(data) {
        let now = new Date();
        let pickedDate = data.date;
        this.invalidDate =
            (pickedDate.getFullYear() == now.getFullYear()) && (pickedDate.getMonth() < now.getMonth())
            || (pickedDate.getFullYear() < now.getFullYear());
        this.form.controls['date'].setValue(data.string);
    }
    changeNameByType(type) {
        this.curr = this.options[type];
    }
    valueChanged(value) {
        this.form.controls.name.setValue(value);
    }
    categoryChanged(category) {
        this.form.controls.category.setValue(category);
    }


    data(data) { }
    error(error) { }
    end() { }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/common/form/form-new.component.ts